import { render, staticRenderFns } from "./GestaoVagasVisualizar.vue?vue&type=template&id=d77b545e&scoped=true"
import script from "./GestaoVagasVisualizar.vue?vue&type=script&lang=js"
export * from "./GestaoVagasVisualizar.vue?vue&type=script&lang=js"
import style0 from "./GestaoVagasVisualizar.vue?vue&type=style&index=0&id=d77b545e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77b545e",
  null
  
)

export default component.exports